module.exports = "/assets/1fa098d3ccb5c92dedbde942c5904eb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MU.png
// module id = 2751
// module chunks = 0